import React, { useState } from "react";
import "./FAQ.scss";
import "../../../pages/uiKit.scss";
import { translateString } from "../../../helpers/translator";

const faqData = [
  {
    id: 1,
    question: "HOME.FAQ.questions.1.question",
    answer: "HOME.FAQ.questions.1.answer",
  },
  {
    id: 2,
    question: "HOME.FAQ.questions.2.question",
    answer: "HOME.FAQ.questions.2.answer",
  },
  {
    id: 3,
    question: "HOME.FAQ.questions.3.question",
    answer: "HOME.FAQ.questions.3.answer",
  },
  {
    id: 4,
    question: "HOME.FAQ.questions.4.question",
    answer: "HOME.FAQ.questions.4.answer",
  },
  {
    id: 5,
    question: "HOME.FAQ.questions.5.question",
    answer: "HOME.FAQ.questions.5.answer",
  },
  {
    id: 6,
    question: "HOME.FAQ.questions.6.question",
    answer: "HOME.FAQ.questions.6.answer",
  },
];

const FAQSection = ({ language }) => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  return (
    <>
      <section className="faq">
        <div className="container">
          <div className="row">
            <div className="faq__intro col-12 col-lg-4">
              <h3 className="section-title">
                {translateString("HOME.FAQ.askQuestion", language)}
              </h3>
              <h2 className="faq__title">
                {translateString("HOME.FAQ.header_1", language)}
              </h2>
              <p className="faq__description">
                {translateString("HOME.FAQ.header_2", language)}
              </p>
            </div>
            <div className="col-12 col-lg-1"></div>
            <div className="faq__list col-12 col-lg-7">
              {faqData.map((q) => (
                <div
                  key={q.id}
                  className={`faq__item ${
                    activeQuestion === q.id ? "faq__item--active" : ""
                  }`}
                >
                  <button
                    className="faq__question"
                    onClick={() =>
                      setActiveQuestion(activeQuestion === q.id ? null : q.id)
                    }
                  >
                    <span className="faq__question-text">
                      <span className="faq__question-index">Q{q.id}</span>
                      {translateString(q.question, language)}
                    </span>
                    <span className="faq__question-symbol">
                      {activeQuestion === q.id ? "[-]" : "[+]"}
                    </span>
                  </button>
                  <div
                    className={`faq__answer ${
                      activeQuestion === q.id
                        ? "faq__answer--visible"
                        : "faq__answer--hidden"
                    }`}
                  >
                    {translateString(q.answer, language)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQSection;
